import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Zoom'

const Wrapper = styled.div`
  @import url('https://fonts.googleapis.com/css?family=PT+Sans+Caption:400,700');
  
  font-family: 'PT Sans Caption', sans-serif;
	display: flex;
	align-items: center;
	flex-direction: column;
  text-align: center;
  padding: 1rem;
  animation: hide;
`

const ImageWrapper = styled.div`
  min-height: 250px;
`

const Image = styled.img`
  max-height: 250px;
`

const Tag = styled.span`
  margin-top: 2rem;
  display: inline-block;
  color: #fff;
  background: ${props => props.color};
  padding: 5px 10px;
  border-radius: 50px;
`

const Header = styled.h1`
  color: #111;
`

const Text = styled.p`
  line-height: 1.4;
  color: #646464;
  margin: 20px 0;
`

const Button = styled.div`
  padding-top: 1rem;
`

const Link = styled.a.attrs({
  target: '_blank',
  rel: 'noreferrer'
})`
  display: inline-block;
  overflow: hidden;
  position: relative;
  color: #111;
  text-decoration: none;
  padding: 10px 15px;
  border: 1px solid #aaa;
  font-weight: bold;
  
  &:hover {
    color: #fff;
    transition: all 200ms ease;
  }
  
  &:hover:after {
    width: 150%;
  }
  
  &:after {
    content: "";
    position: absolute;
    top: 0;
    width: 0%;
    background: ${props => props.color};
    height: 100%;
    z-index: -1;
    transition: width 0.3s ease-in-out; 
  }
`

const LinkLeft = styled(Link)`
  border-radius: 50px 0 0 50px;
  border-right: none;
    
  &:hover:after {
    right: -10px;
  }
  
  &:after {
    right: -10px;
  }
`

const LinkRight = styled(Link)`
  border-radius: 0px 50px 50px 0;
  
  &:hover:after {
    left: -10px;
  }
  
  &:after {
    left: -10px;
  }
`

// wait 750ms for image to load
const DELAY = 750

const SlidingProduct = ({image, primaryColor, tagText, header, text, buttonTextLeft, buttonTextRight, link}) =>
  <Wrapper>

    <Fade top ssrReveal delay={DELAY}>
      <ImageWrapper>
        <Image src={image} />
      </ImageWrapper>
    </Fade>

    <Fade bottom ssrReveal delay={DELAY}>

      <Tag color={primaryColor}>{tagText}</Tag>
      <Header>{header}</Header>

      {text && <Text>{text}</Text>}

      <Button>
        <LinkLeft href={link} color={primaryColor}>{buttonTextLeft}</LinkLeft>
        <LinkRight href={link} color={primaryColor}>{buttonTextRight}</LinkRight>
      </Button>

    </Fade>

  </Wrapper>

export default SlidingProduct